import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { InterviewerInterviewPlanned } from "./../../../Redux/action/InterviewerInterviewPlanned";

import { JobsInterviewPlannedAcceptAction } from "./../../../Redux/action/JobsInterviewPlannedAcceptAction";
import RejectJob from "./RejectJob";
import { BiArrowBack } from "react-icons/bi";
import { Toast, ToastContainer, toast } from "react-toastify";

import { FaCheck } from "react-icons/fa6";
import { MdOutlineCancel } from "react-icons/md";
import { TbExternalLink } from "react-icons/tb";
import DeactivateModal from "../../Common/DeactivateMemberModal";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextareaAutosize } from "@mui/material";
import axios from "axios";
import { SpinLoader } from "../../Vendor/ImportCandidates";
import AssignedInterviewsInfo from "./AssignedInterviewsInfo";
import Pagination from '../../Common/Pagination/Pagination';
import { CandidateProfile } from "../../../Redux/action/CandidateProfileAction";
import { VendorProfile } from "../../../Redux/action/VendorProfileAction";



const JobsInterviewPlanned = () => {
    const { userResult } = useSelector((state) => state.Auth);
    const candidateIdData = localStorage.getItem("candidateVendorId");
    const userIdData = userResult?.userid;;

    const dataAssignedInterview = useSelector((state) => state?.InterviewerInterviewPlannedReducer?.result?.content);
    const [rerender, setRerender] = useState(false);
    console.log("asssiign interv... ", dataAssignedInterview);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedCandidates, setSelectedCandidates] = useState([]);
    const [selectedReason, setSelectedReason] = useState(""); // To store the selected reason
    const [otherReason, setOtherReason] = useState("");
    const [showOtherTextarea, setShowOtherTextarea] = useState(selectedReason === "other");

    const [loading, setLoading] = useState(false);
    const [componentKey, setComponentKey] = useState(0);
    const [interviewId, setInterviewId] = useState("")

    const [pageNumber, setPageNumber] = useState(0);
    const totalPages = useSelector((state) => state?.InterviewerInterviewPlannedReducer?.result?.totalPages);
    // console.log("ppppp",totalPages)
    const handlePageChange = (page) => {
        setPageNumber(page);
    };

    let navigate = useNavigate();
    let dispatch = useDispatch();

    const baseUrl = process.env.REACT_APP_API_PATH;


    const candidateId = userResult?.userid;;
    const candidateVendorId = localStorage.getItem("candidateVendorId");
    useEffect(() => {
        if (candidateIdData) {
            dispatch(CandidateProfile(userIdData));
            dispatch(VendorProfile(candidateIdData));
        }
    }, [candidateIdData]);
    useEffect(() => {
        dispatch(InterviewerInterviewPlanned(candidateId));
    }, [rerender, pageNumber]);

    const AcceptInterview = (interviewId) => {
        const content = {
            isAcceptedByInterviewer: "ACCEPTED",
            interviewId,
        };
        dispatch(JobsInterviewPlannedAcceptAction(content)).then(() => dispatch(InterviewerInterviewPlanned(candidateId)));
        setRerender(!rerender);
    };

    const handleReasonChange = (event) => {
        const value = event.target.value;
        setSelectedReason(value);

        // If "other" is selected, show the textarea
        setShowOtherTextarea(value === "other");
    };

    const handleOtherReasonChange = (event) => {
        setOtherReason(event.target.value);
    };

    const openModal = (e, intId) => {
        e.stopPropagation()
        setIsModalOpen(true);
        setInterviewId(intId)
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };



    const handleSubmit = async (e) => {
        setLoading(true);
        let timeout;
        try {
            const content = {
                isAcceptedByInterviewer: "REJECTED",
                declineReasonInterviewer: selectedReason !== 'other' ? selectedReason : otherReason,
                interviewId
            }
            await axios.put(`${baseUrl}/ebench/interview/accept_or_reject_interview`
                , content,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }).then(() => (dispatch(InterviewerInterviewPlanned(candidateId))))

            setLoading(false)
            setSelectedReason("")
            setSelectedCandidates([])
            closeModal();
            setComponentKey((prevKey) => prevKey + 1);

            toast.error('Interview Rejected')
        } catch (error) {
            setLoading(false)
            console.error("Error occurred", error);
            toast.error(error.response.data.status.message);
        }

        return () => {
            clearTimeout(timeout)
        }

    }

    const handleCheck = (e, id) => {
        e.stopPropagation()
        AcceptInterview(id)

    }

    return (
        <div className="">
            <ToastContainer />
            <div>

                {/* <div className="searchCanHead"></div> */}
            </div>
            <div className="common_wrapper mt-3">
                <div className="card-header common_table_header">
                    Assigned interviews
                </div>
                <div className="card-body  ">
                    <div className="table-responsive">
                        <table className="table-data" style={{ width: '100%', textAlign: 'center', fontSize: "14px" }}>
                            <thead>
                                <tr>
                                    <th className="fw_600" scope="col">ID</th>
                                    <th className="fw_600" scope="col">Candidate Name</th>
                                    <th className="fw_600" scope="col">Round</th>
                                    <th className="fw_600" scope="col">Job ID</th>
                                    <th className="fw_600" scope="col">Designation</th>
                                    <th className="fw_600" scope="col">Date</th>
                                    {/* <th className="fw_600" scope="col">Start Time</th> */}
                                    <th className="fw_600" scope="col">Duration</th>
                                    {candidateVendorId == "null" && <th className="fw_600" scope="col">Hiring Status</th>}
                                    <th className="fw_600" scope="col">Score</th>
                                    <th className="fw_600" scope="col">Status</th>
                                    <th className="fw_600" scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {dataAssignedInterview &&
                                    dataAssignedInterview?.map((item, i) => {
                                        console.log('ITEM--', item)
                                        return (
                                            <>
                                                <tr style={{ cursor: "pointer" }} onClick={() => navigate("/assigned_interviews_info", { state: { dataToSend: item?.interviewId } })} key={i}>

                                                    <td>{item?.interviewId}</td>
                                                    <td>{item?.candidateName}</td>
                                                    <td>{item?.round}</td>
                                                    <td>{item?.jobUuid}</td>
                                                    <td>{item?.jobPosition}</td>
                                                    <td>
                                                        {
                                                            item?.interviewDate.split(" ")[0].split("-")[2] + "-" +
                                                            item?.interviewDate.split(" ")[0].split("-")[1] + "-" +
                                                            item?.interviewDate.split(" ")[0].split("-")[0]
                                                            || "N/A"}
                                                    </td>
                                                    {/* <td>
                                                        {item.interviewStartTime}
                                                    </td> */}
                                                    <td>{item?.duration}</td>

                                                    {candidateVendorId == "null" && <td>
                                                        {
                                                            item?.candidateInterviewStatus
                                                        }
                                                    </td>}
                                                    <td>{item?.rating ? item?.rating + "/5" : "-"}</td>

                                                    <td>
                                                        {<div className={`w-75 m-auto ${item.interviewStatus === "SCHEDULED"
                                                                ? "yellow_status"
                                                                : item.interviewStatus === "CANCELLED"
                                                                    ? "red_status"
                                                                    : "green_status"
                                                            }`}
                                                        >
                                                            {item.interviewStatus}
                                                        </div>}</td>

                                                    {((item?.isAcceptedByInterviewer == "PENDING") && (item?.interviewStatus == "SCHEDULED")) ? (
                                                        <>
                                                            <td>
                                                                <FaCheck
                                                                    size={23}
                                                                    color="#286a94"
                                                                    className="me-3 pointer"
                                                                    onClick={(e) => handleCheck(e, item?.interviewId)}
                                                                />
                                                                <MdOutlineCancel size={23}
                                                                    color="red" className="pointer" onClick={(e) => openModal(e, item?.interviewId)}>

                                                                    {/* <RejectJob
                                                                        interviewData={
                                                                            item.interviewId
                                                                        }
                                                                    /> */}
                                                                </MdOutlineCancel>
                                                            </td>
                                                        </>
                                                    ) : (
                                                        <td>
                                                            {
                                                                item?.isAcceptedByInterviewer
                                                            }
                                                        </td>
                                                    )}

                                                </tr>
                                            </>
                                        );
                                    })}
                            </tbody>
                        </table>
                        {dataAssignedInterview?.length === 0 && (
                            <div className="text-center mt-5">
                                <h5>No Data Found</h5>
                            </div>
                        )}
                    </div>
                </div>
                <DeactivateModal isOpen={isModalOpen} onClose={closeModal} heading={'Reason for Rejection'} >
                    <FormControl>
                        <FormLabel id="demo-radio-buttons-group-label">Reasons</FormLabel>
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            // defaultValue="female"
                            name="radio-buttons-group"
                            value={selectedReason}
                            onChange={handleReasonChange}
                        >
                            <FormControlLabel className='mb-2' value="I am not available" control={<Radio />} label="I am not available" />

                            <FormControlLabel className='mb-2' value="Better opportunities elsewhere" control={<Radio />} label="Better opportunities elsewhere" />

                            <FormControlLabel className='mb-2' value="Lack of clarity about the role or expectations" control={<Radio />} label="Lack of clarity about the role or expectations" />

                            <FormControlLabel className='mb-2' control={<Radio />} value={'other'} label="Others"
                            //  onClick={handleOtherReason}
                            />

                            {showOtherTextarea && (
                                <TextareaAutosize
                                    value={otherReason}
                                    onChange={handleOtherReasonChange}
                                    placeholder="Other Reason"
                                    minRows={5}
                                    maxRows={5}
                                />
                            )}
                        </RadioGroup>


                        <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>
                            <button
                                variant="contained"
                                className="common_btn"
                                style={{
                                    background: '#1c6597', color: '#fff', marginRight: '10px', width: "100px",
                                    height: "40px",
                                }}
                                onClick={handleSubmit} // Add your submit logic here
                            >
                                {!loading ? "Submit" : <SpinLoader />}
                            </button>
                            {/* <button
                                    className="btn btn-danger rounded-0"
                                    onClick={closeModal}
                                >
                                    Cancel
                                </button> */}
                        </div>
                    </FormControl>
                </DeactivateModal>
            </div>
            {
                dataAssignedInterview?.length > 0 &&
                <Pagination totalPages={totalPages} currentPage={pageNumber} onPageChange={handlePageChange} />
            }

        </div>
    );
};

export default JobsInterviewPlanned;
